module.exports = __webpack_public_path__ + "img/banner3.41a28b0c.png";